// export const API_URL = 'https://api.goldenpharma.octopharma.net/api';
// export const API_URL = 'https://api.oubari.octopharma.net/api';
// export const API_URL = 'https://mirror-api.octopharma.net/api';
// export const API_URL = 'https://mirta-mirror-api.octopharma.net/api';
// export const API_URL = 'https://api.ibn-alhaytham.octopharma.net/api';
// export const API_URL = 'https://alradwan-mirror-api.octopharma.net/api';
// export const API_URL = 'https://api.alradwan.octopharma.net/api';
// export const API_URL = 'https://api.media-pharma.octopharma.net/api'
// export const API_URL = 'https://olabi-mirror-api.octopharma.net/api'
// export const API_URL = 'https://api.alkhalil.octopharma.net/api'
// export const API_URL = 'https://olabi-mirror-api.octopharma.net/api'
// export const API_URL = 'https://api.ibn-alhaytham.octopharma.net/api'
// export const API_URL = 'https://api.ibn-alhaytham.octopharma.net/api'
export const API_URL = 'https://mirror2-api.octopharma.net/api'
// export const API_URL = 'https://bon-lux-api.octopharma.net/api'
export const VERSION = '2.8.1';

// AES-256-CBC key backend uses to encode entity data into QR codes (see /entities/qrCode/decode).
// Kept here alongside API_URL since it's tied to this tenant's backend, not shared across deployments.
export const QR_SECURITY_CODE = 'PxyMyG+DqSgwXnf5qw706RbrK/mkj0KwprzuApEEUpI=';

// Levantine month names (moment has no built-in locale with these) used for Arabic date display.
export const ARABIC_MONTHS = [
	'كانون الثاني', 'شباط', 'آذار', 'نيسان', 'أيار', 'حزيران',
	'تموز', 'آب', 'أيلول', 'تشرين الأول', 'تشرين الثاني', 'كانون الأول'
];

// Indexed like moment's day() (0 = Sunday ... 6 = Saturday), used for Arabic date display.
export const ARABIC_WEEKDAYS = [
	'الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'
];
